import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Card, Table, Button } from "react-bootstrap";
import { Divider } from "rsuite";
import classes from "./Inventory.module.css";
import PermissionContext from "../../Store/permission-context";
const Inventory = () => {
  const [AxiosError, setAxiosError] = useState("");
  const [AllTheExpiredGoods, setAllTheExpiredGoods] = useState([]);
  const [Itemname, setItemname] = useState("");
  const [AllGoodNames, setAllGoodNames] = useState("");
  const [Reload, setReload] = useState(false);
  const [showModal, setshowModal] = useState(false);
  const [DisableTheButton, setDisableTheButton] = useState(false);
  const [SentRecord, setSentRecord] = useState({});
  const [GoodToDelete, setGoodToDelete] = useState({});
  const [ShowYesModal, setShowYesModal] = useState(false);
  const [Message, setMessage] = useState("");
  const PCtx = useContext(PermissionContext);

  useEffect(() => {
    const GetExpiredGoods = async () => {
      let AllExpiredGoods = await PCtx.connectAxios("getexpiredgoods.php", "");
      console.log(AllExpiredGoods);
      if (Array.isArray(AllExpiredGoods) && AllExpiredGoods.length > 0) {
        setAllTheExpiredGoods(AllExpiredGoods);
      }
    };
    GetExpiredGoods();
  }, [Reload]);

  const StopAlertHandler = async (ItemId) => {
    let IgnoreDetails = { It: ItemId, User: PCtx.Username };
    let response = await PCtx.connectAxios("stopalert.php", IgnoreDetails);
    console.log(response);
    if (response.includes("Success")) {
      setReload(!Reload);

      PCtx.displayAlert(
        "SUCCESS",
        "This will be ignored on subsequent Notifications",
        "success"
      );
      setDisableTheButton(true);
    }
  };

  return (
    <Row className="justify-content-center">
      <Col md={12} className={classes.margin4printing}>
        <Row className={classes.hide4printing}>
          <Col md={12}>
            <Card style={{ height: "35px" }}>
              <Card.Body>
                <h4
                  className="text-center "
                  style={{ color: "brown", fontFamily: "Times New Roman" }}
                >
                  <Divider className="m-0"> EXPIRED ITEMS LIST</Divider>
                </h4>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Col>
      <Col md={12} sm={12} xs={12}>
        <p
          className="text-center"
          style={{
            fontFamily: "Times New Roman",
            color: "brown",
            fontSize: "25px",
          }}
        >
          The following Items will expire soon
        </p>
      </Col>
      <hr />

      <Col md={12} sm={12} xs={12}>
        <Row>
          <Col md={12} sm={12} xs={12}>
            <Table
              striped
              bordered
              hover
              style={{ fontFamily: "Times New Roman" }}
            >
              <thead>
                <tr>
                  <th
                    className="text-center"
                    style={{
                      position: "sticky",
                      top: "-1px",
                      backgroundColor: "brown",
                      color: "white",
                    }}
                  >
                    SN
                  </th>
                  <th
                    className="text-center"
                    style={{
                      position: "sticky",
                      top: "-1px",
                      backgroundColor: "brown",
                      color: "white",
                    }}
                  >
                    Item Name
                  </th>
                  <th
                    className="text-center"
                    style={{
                      position: "sticky",
                      top: "-1px",
                      backgroundColor: "brown",
                      color: "white",
                    }}
                  >
                    Date Supplied
                  </th>

                  <th
                    className="text-center"
                    style={{
                      position: "sticky",
                      top: "-1px",
                      backgroundColor: "brown",
                      color: "white",
                    }}
                  >
                    Expiry Date (Days left)
                  </th>

                  <th
                    className="text-center"
                    style={{
                      position: "sticky",
                      top: "-1px",
                      backgroundColor: "brown",
                      color: "white",
                    }}
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {AllTheExpiredGoods.map((exp, index) => (
                  <tr>
                    <th
                      className="text-center"
                      style={{
                        position: "sticky",
                        top: "-1px",

                        color: "black",
                      }}
                    >
                      {index + 1}
                    </th>
                    <th
                      className="text-center"
                      style={{
                        position: "sticky",
                        top: "-1px",

                        color: "black",
                      }}
                    >
                      {exp.Itemname}
                    </th>
                    <th
                      className="text-center"
                      style={{
                        position: "sticky",
                        top: "-1px",

                        color: "black",
                      }}
                    >
                      {exp.Supplieddate}
                    </th>

                    <th
                      className="text-center"
                      style={{
                        position: "sticky",
                        top: "-1px",

                        color: "black",
                      }}
                    >
                      {exp.Expirydated + " (" + exp.toExp + " days)"}
                    </th>
                    <th
                      className="text-center"
                      style={{
                        position: "sticky",
                        top: "-1px",

                        color: "black",
                      }}
                    >
                      <Button
                        variant="outline-danger"
                        onClick={() => StopAlertHandler(exp.SN, index)}
                      >
                        Ignore
                      </Button>
                    </th>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Col>
      {/* {showModal && (
        <EditInventoryModal
          cancelModal={cancelModal}
          Invrec={SentRecord}
          show={showModal}
          SaveNewRecord={SaveNewRecord}
        />
      )}
   
      {ShowYesModal && (
        <YesAndNoModal
          showmodal={ShowYesModal}
          message={Message}
          modaltype="Error"
          deletereceipt={DeleteRecord}
          NextEvent={NextEvent}
        />
      )}
         */}
    </Row>
  );
};

export default Inventory;
